<div class="transport-list">
  <sc-no-data fitHeight *ngIf="dataSource.data.length == 0" class="no-data"></sc-no-data>
  <sc-scroll-pane (onScroll)="handleScroll($event)">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortChanged($event)" class="transport-table">

      <ng-container matColumnDef="hint">

        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.hint"></sc-dictionary-label>
        </th>

        <td mat-cell *matCellDef="let transport" [ngClass]="{'selected' : transport.id === selectedId }"
          class="hint-column {{transport.statusStyle}}">
          <sc-flex>

            <app-transport-scope-icon [scope]="transport.transportScope"
              [type]="transport.transportType"></app-transport-scope-icon>

            <ng-container *ngIf="transport.useGlobalConnect">
              <sc-content-spacer [half]="true"></sc-content-spacer>
              <sc-icon iconClass="fa-qrcode"></sc-icon>
            </ng-container>

            <ng-container *ngIf="transport.useSms">
              <sc-content-spacer [half]="true"></sc-content-spacer>
              <sc-icon iconClass="fa-message-sms"></sc-icon>
            </ng-container>

            <ng-container *ngIf="transport.usePager">
              <sc-content-spacer [half]="true"></sc-content-spacer>
              <sc-icon iconClass="fa-wifi"></sc-icon>
            </ng-container>

            <ng-container *ngIf="transport.important">
              <sc-content-spacer [half]="true"></sc-content-spacer>
              <sc-icon iconClass="fa-exclamation"></sc-icon>
            </ng-container>

            <ng-container *ngIf="transport.urgent">
              <sc-content-spacer [half]="true"></sc-content-spacer>
              <sc-icon iconClass="fa-truck-fast"></sc-icon>
            </ng-container>

            <ng-container *ngIf="transport.intermitted">
              <sc-content-spacer [half]="true"></sc-content-spacer>
              <sc-icon iconClass="fa-octagon-xmark"></sc-icon>
            </ng-container>

            <ng-container *ngIf="transport.inUmbrueckung">
              <sc-content-spacer [half]="true"></sc-content-spacer>
              <sc-icon iconClass="fa-shuffle"></sc-icon>
            </ng-container>

            <ng-container *ngIf="transport.dangerousGoods">
              <sc-content-spacer [half]="true"></sc-content-spacer>
              <sc-icon iconClass="fa-skull-crossbones"></sc-icon>
            </ng-container>

            <ng-container *ngIf="transport.pendingTaskState !== PendingTaskState.NONE">
              <sc-content-spacer [half]="true"></sc-content-spacer>
              <app-task-state-icon [state]="transport.pendingTaskState"></app-task-state-icon>
            </ng-container>

            <ng-container *ngIf="transport.hasMovementOrder">
              <sc-content-spacer [half]="true"></sc-content-spacer>
              <sc-icon iconClass="fa-truck-flatbed"></sc-icon>
            </ng-container>

          </sc-flex>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="detail.identifier" *ngFor="let detail of possibleColumns">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.{{detail.attribute}}"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection {{transport.statusStyle}} {{detail.dataType}} {{detail.identifier}}-column"
          *matCellDef="let transport" [ngClass]="{'selected' : transport.id === selectedId}">
          <span class="value">
            {{ transport[detail.identifier] | transportColumnFormat:[detail] }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="filler">
        <th mat-header-cell *matHeaderCellDef style="width: 100%;"> &nbsp; </th>
        <td mat-cell *matCellDef="let transport" [ngClass]="{'selected' : transport.id === selectedId}"
          class="{{transport.statusStyle}}"> &nbsp;</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

      <tr mat-row *matRowDef="let transport; columns: columnsToDisplay" [attr.data-transport-id]="transport.id"
        [ngClass]="[transport.highlightingStyle, transport.tableRowStyles]" (click)="onClickRow(transport)"></tr>

    </table>
  </sc-scroll-pane>
</div>
